export const ROLLBACK_ENUM = {
  SEQUENCE: 'sequence', //按照顺序重新提交
  BACK_TRACKED: 'backtracked' //提交给退回节点
}